import { useTranslation } from 'react-i18next';

import { Placeholder } from './PlaceHolder';

const MovingGoalPlaceholder = (props: any) => {
  const { t } = useTranslation();
  return (
    <Placeholder
      placeholderText={t('You cannot add Unmerged Goals to a loop.')}
      {...props}
    />
  );
};

export default MovingGoalPlaceholder;
